// Parent grid columns: [select] SKU/Description · Unit status · Qty · Pallet · Status [kebab].
// Child columns are config-driven (they differ inbound vs outbound), built in ManifestLineRow.
export const PARENT_COLUMNS = '34px minmax(0, 2.2fr) 0.95fr 0.5fr 0.95fr 0.82fr 34px';

// Generic pool location written by "Relocate to dock".
export const DOCK_LOCATION = 'DOCK';
